import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const getNotifications = catchAsync(async (lang) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.get_notifications?_lang=${lang}`
  );
  return data;
});
